import { Opcion } from './opcion';

export class Pregunta {
    public id: number = Math.floor(0);
    public idAsamblea: number = Math.floor(0);
    public descripcion = '';
    public orden: number;
    public estado = '';
    public tiempoAsignado: number = Math.floor(0);
    public tiempoAdicional: number = Math.floor(0);
    public fechaInicio = '';
    public fechaFin = '';
    public idOpcion: number;
    public mensajePregunta = '';
    public tipoPregunta: number = Math.floor(0);
    public numOpc: number = Math.floor(0);
    public opciones: Opcion[] = [];
    public isDisabled = false;

    constructor(init?: Partial<Pregunta>) {
        Object.assign(this, init);
    }
}
